import { SVGProps } from '@components/Icon/types';

export const Leave = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(2, 2.5)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.5472 3.10204H13.7736V1.55102C13.7736 0.697959 13.0943 0 12.2642 0H7.73585C6.90566 0 6.22642 0.697959 6.22642 1.55102V3.10204H2.45283C1.09434 3.10204 0 4.22653 0 5.62245V16.4796C0 17.8755 1.09434 19 2.45283 19H17.5472C18.9057 19 20 17.8755 20 16.4796V5.62245C20 4.22653 18.9057 3.10204 17.5472 3.10204ZM7.35849 1.55102C7.35849 1.33776 7.5283 1.16327 7.73585 1.16327H12.2642C12.4717 1.16327 12.6415 1.33776 12.6415 1.55102V3.10204H7.35849V1.55102ZM3.77358 17.8367H2.45283C1.71698 17.8367 1.13208 17.2357 1.13208 16.4796V5.62245C1.13208 4.86633 1.71698 4.26531 2.45283 4.26531H3.77358H4.90566H15.0943H16.2264H17.5472C18.283 4.26531 18.8679 4.86633 18.8679 5.62245V16.4796C18.8679 17.2357 18.283 17.8367 17.5472 17.8367H16.2264H15.0943H4.90566H3.77358Z"
        fill={fill}
      />
      <path d="M15.0943 4.26531V17.8367H16.2264V4.26531H15.0943Z" fill={fill} />
      <path d="M3.77358 4.26531V17.8367H4.90566V4.26531H3.77358Z" fill={fill} />
    </g>
  </svg>
);

export const ICON_NAME = 'leave';
